<script>
import { required } from "vuelidate/lib/validators";
import Loader from "../widgets/loader.vue";
import VueTypeaheadBootstrap from "@/components/vueTypeAheadBootstrap/VueTypeaheadBootstrap";

// Custom Components
import DataUpdateInfo from "@/components/dataUpdateInfo.vue";
import PbxService from "@/helpers/APIService/pbx.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";

export default {
  data() {
    return {
      device_profile_form: {
        model: "",
        vendor: "",
        line: "",
        type: "",
        device_authentication: "",
        device_password: "",
      },
      templates: [""],
      domaindata: [],
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      isLoadingEdit: false,
      template_value: "",
      dataToBeUpdate: {},
    };
  },
  props: {
    deviceProfileId: String,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    device_profile_form: {
      model: { required },
      vendor: { required },
      line: { required },
      type: { required },
    },
  },
  components: {
    VueTypeaheadBootstrap,
    Loader,
    DataUpdateInfo,
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to set default value
    setValue() {
      if (this.isEdit) {
        this.isLoadingEdit = true;
        PbxService.getDeviceProfileDetail(this.deviceProfileId)
          .then((response) => {
            const pbxServerDetails = response.result;
            Object.keys(pbxServerDetails).map((key) => {
              if (
                pbxServerDetails[key] !== null ||
                pbxServerDetails[key] !== undefined
              ) {
                if (key === "template") {
                  this.templates =
                    typeof pbxServerDetails[key] == "object"
                      ? pbxServerDetails[key]
                      : JSON.parse(pbxServerDetails[key]);
                } else {
                  this.device_profile_form[key] = pbxServerDetails[key];
                }
              }
            });
            this.dataToBeUpdate = {
              created_by: pbxServerDetails.created_by,
              created_at: pbxServerDetails.created_at,
              updated_by: pbxServerDetails.updated_by,
              updated_at: pbxServerDetails.updated_at,
            };
            this.isLoadingEdit = false;
          })
          .catch((error) => {
            errorHandler(error);
            this.isLoadingEdit = false;
          });
      }
    },
    // Method is used to handle submit device profile
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {};
        Object.keys(this.device_profile_form).map((key) => {
          if (
            this.device_profile_form[key] !== null &&
            this.device_profile_form[key] !== undefined
          ) {
            data[key] = this.device_profile_form[key];
          }
        });
        data = {
          ...data,
          line: String(data.line),
          template: JSON.stringify(this.templates),
        };
        if (this.isEdit) {
          PbxService.updateDeviceProfileDetail(this.deviceProfileId, data)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              Middleware.notification("Successfully updated !!", "success");
              this.$emit("submitted", response.result);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          PbxService.addDeviceProfileDetail(data)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              Middleware.notification("Successfully added !!", "success");
              this.$emit("submitted", response.result);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
    // Method is used to add and remove template from templates
    handleTemplate(action, index) {
      if (action == "add") {
        this.templates.push("");
      }
      if (action == "remove") {
        this.templates.splice(index, 1);
      }
    },
    handleHit(trackBy, data = null) {},
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ isEdit ? "Update" : "Add New" }} Device Profile</h4>
        <hr />

        <div class="row align-items-end">
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="model">
              <span slot="label">
                Model <span class="text-danger">*</span></span
              >
              <b-form-input
                id="model"
                type="url"
                autocomplete="off"
                v-model="device_profile_form.model"
                :class="{
                  'is-invalid':
                    submitted && $v.device_profile_form.model.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.device_profile_form.model.required"
                  >Model is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="vendor">
              <span slot="label">
                Vender <span class="text-danger">*</span></span
              >
              <vue-typeahead-bootstrap
                v-model="device_profile_form.vendor"
                @hit="handleHit"
                :data="domaindata"
                trackby="domain_name"
                placeholder="Search vendor"
                :class="{
                  'is-invalid':
                    submitted && $v.device_profile_form.vendor.$error,
                }"
              />
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.device_profile_form.vendor.required"
                  >Vender is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="line">
              <span slot="label"> Line <span class="text-danger">*</span></span>
              <b-form-input
                id="line"
                type="number"
                autocomplete="off"
                v-model="device_profile_form.line"
                :class="{
                  'is-invalid': submitted && $v.device_profile_form.line.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.device_profile_form.line.required"
                  >Line is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="type">
              <span slot="label"> Type <span class="text-danger">*</span></span>
              <b-form-input
                id="type"
                type="text"
                autocomplete="off"
                v-model="device_profile_form.type"
                :class="{
                  'is-invalid': submitted && $v.device_profile_form.type.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.device_profile_form.type.required"
                  >Type is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="device_username">
              <span slot="label"> Device Username </span>
              <b-form-input
                id="type"
                type="text"
                autocomplete="off"
                v-model="device_profile_form.device_authentication"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6">
            <b-form-group class="mb-3" label-for="device_password">
              <span slot="label"> Device Password </span>
              <b-form-input
                id="type"
                type="text"
                autocomplete="off"
                v-model="device_profile_form.device_password"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-6" v-for="(tem, index) in templates" :key="index">
            <div class="row align-items-center">
              <div :class="index == 0 ? 'col-md-12' : 'col-11'">
                <b-form-group class="mb-3" label-for="template">
                  <span slot="label"> Template ({{ index + 1 }})</span>
                  <b-form-input
                    id="template"
                    type="text"
                    autocomplete="off"
                    v-model="templates[index]"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-1" v-if="index !== 0">
                <i
                  class="mdi mdi-trash-can fs-4 text-danger"
                  @click="handleTemplate('remove', index)"
                ></i>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="mb-3">
              <b-button
                variant="primary"
                id="add_row"
                @click="handleTemplate('add')"
              >
                + Add Template
              </b-button>
            </div>
          </div>
          <div class="col-sm-12">
            <b-alert v-if="isError" show variant="danger">
              <ul>
                <li v-for="(error, index) in errorMessage" :key="index">
                  {{ index }}: {{ error[0] }}
                </li>
              </ul>
            </b-alert>
          </div>
          <hr />
          <div class="col-sm-12">
            <b-button
              class="float-end ms-2 mb-3"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end mb-3"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ isEdit ? "Update" : "Save" }}
            </b-button>
            <DataUpdateInfo :data-to-be-show="dataToBeUpdate" />
          </div>
        </div>
        <Loader :loading="{ isLoading: isLoadingEdit }" />
      </div>
    </div>
  </div>
</template>
